import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "nativewind/jsx-runtime";
import React from 'react';
import { Image } from 'react-native';
import { BadgeShell, BadgeText } from '@/components/BadgeShell';
import GradientBorderPill from '@/components/GradientBorderPill';
import SccRemoteImage from '@/components/SccRemoteImage';
import { SccTouchableOpacity } from '@/components/SccTouchableOpacity';
import { color } from '@/constant/color';
const savedListBadgeImage = require('@/assets/img/ic_saved_list_badge.png');
/**
 * 저장리스트 이름칩 — 앱 전체(검색 카드/PDP/저장리스트 상세헤더/모음 페이지)에서
 * 이 칩의 유일한 구현. 두 번째 칩 컴포넌트를 만들면 spec 위반.
 *
 * 아이콘/배경색/테두리색이 전부 미지정이면 현행 PlaceTags와 픽셀 동일하게 렌더한다
 * (fallback 분기가 아니라 이 컴포넌트의 기본 렌더링).
 */
export default function PlaceListNameChip({ text, iconUrl, backgroundColor, borderColor, onPress, elementName, logParams, trackView, }) {
    if (!iconUrl && !backgroundColor && !borderColor) {
        const pill = (_jsxs(GradientBorderPill, { borderWidth: 1, gradientId: "tag-gradient", contentStyle: {
                paddingTop: 4,
                paddingBottom: 4,
                paddingLeft: 6,
                paddingRight: 8,
                gap: 4,
            }, children: [_jsx(Image, { source: savedListBadgeImage, style: { width: 16, height: 16 }, resizeMode: "contain" }), _jsx(BadgeText, { textColor: color.gray80, children: text })] }));
        if (!onPress) {
            return pill;
        }
        return (_jsx(SccTouchableOpacity, { elementName: elementName !== null && elementName !== void 0 ? elementName : 'place_list_name_chip', logParams: logParams, trackView: trackView, onPress: onPress, children: pill }));
    }
    const content = (_jsxs(_Fragment, { children: [iconUrl ? (_jsx(SccRemoteImage, { imageUrl: iconUrl, style: { width: 16, height: 16 }, wrapperBackgroundColor: null })) : null, _jsx(BadgeText, { textColor: color.gray80v2, children: text })] }));
    if (!onPress) {
        return (_jsx(BadgeShell, { backgroundColor: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : color.white, textColor: color.gray80v2, borderColor: borderColor !== null && borderColor !== void 0 ? borderColor : undefined, borderRadius: 100, paddingHorizontal: 6, style: { paddingRight: 8 }, children: content }));
    }
    return (_jsx(BadgeShell, { backgroundColor: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : color.white, textColor: color.gray80v2, borderColor: borderColor !== null && borderColor !== void 0 ? borderColor : undefined, borderRadius: 100, paddingHorizontal: 6, style: { paddingRight: 8 }, elementName: elementName !== null && elementName !== void 0 ? elementName : 'place_list_name_chip', logParams: logParams, trackView: trackView, onPress: onPress, children: content }));
}
